import { CSSObject } from '@chakra-ui/react';
import { TBetReturn } from '../HeaderRow.types';

export const TextDescription: CSSObject = {
  textTransform: 'capitalize',
};

export const RunnerDetails: CSSObject = {
  color: 'alpha.400',
  fontSize: 'xs',
};

export const RunnerDescription: CSSObject = {
  color: 'gray.400',
};

export const HeaderSvg: CSSObject = {
  borderRadius: 'none',
  bg: 'transparent',
  color: 'alpha.400',
  boxSize: '8',
  p: '1',
};

export const BetMultiIcon: CSSObject = {
  bg: 'transparent',
  boxSize: '10',
  color: 'alpha.400',
  p: '1',
};

export const BetReturn = (status: TBetReturn): CSSObject => ({
  bg: () => {
    switch (status) {
      case 'won':
        return 'green.400';
      case 'lost':
        return 'alpha.900';
      case 'pending':
        return 'beta.600';
      default:
    }
  },
  color: () => {
    switch (status) {
      case 'won':
        return 'white';
      case 'lost':
        return 'beta.400';
      case 'pending':
        return 'alpha.700';
      default:
    }
  },
});

export const BetOdds: CSSObject = {
  color: 'gray.700',
};

export const TextBarrierNumber: CSSObject = {
  color: 'alpha.400',
};
